import { getMessages } from '../../../../../../../store/constants';

export const SET_IN_WORK_CARD_TOOLTIP = getMessages().getText('card_form_action_set_in_work_card_tooltip');
export const UNSET_IN_WORK_CARD_TOOLTIP = getMessages().getText('card_form_action_unset_in_work_card_tooltip');
